import { TFunction } from 'i18next'
import { z } from 'zod'

// Note: ids only (not the legacy {saltoId, name} pairs) — matches ChipSelectFormField's
// shape. Names are looked back up from the access-points list at submit time, see
// use-salto-space-submit.ts.
export const makeSaltoSpaceConnectionSchema = (t: TFunction<['organisation', 'common']>) =>
  z.object({
    apiKey: z.string().min(1, t('organisation:places.integrations.salto.errors.apiKey')),
    residentAccessLevelIds: z.array(z.string()),
    residentZoneIds: z.array(z.string()),
    shouldAutoAssignApartmentDoor: z.boolean(),
    shouldAutoAssignUserAccessLevel: z.boolean(),
    url: z.string().min(1, t('organisation:places.integrations.salto.errors.url')),
    visitorAccessLevelIds: z.array(z.string()),
    visitorZoneIds: z.array(z.string()),
  })

export type SaltoSpaceConnectionFormValues = z.infer<
  ReturnType<typeof makeSaltoSpaceConnectionSchema>
>

export const saltoSpaceDefaultValues: SaltoSpaceConnectionFormValues = {
  apiKey: '',
  residentAccessLevelIds: [],
  residentZoneIds: [],
  shouldAutoAssignApartmentDoor: false,
  shouldAutoAssignUserAccessLevel: false,
  url: '',
  visitorAccessLevelIds: [],
  visitorZoneIds: [],
}
